import React from 'react'

export default function SearchHeader(){
    return (
        <header className='search-header'>
            <h1 className='search-title'>Subscriptions</h1>
        </header>
    )
}